// extracted by mini-css-extract-plugin
export default {"head":"goBack_head__YxnCm","arrow":"goBack_arrow__O5pNZ","back":"goBack_back__jD9Et"};